import { CotizacionForm } from "./CotizacionForm";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { cotizacionStartAdd, cotizacionStartUpdate } from "../../../actions";
import { FormUi } from "./../../ui";
import { Form } from "antd";
import { cleanEmptyChildren, parseDateFormatBackEnd } from "../../../helpers";
const initialValues = (data = {}) => ({
  id: data?.id || dayjs().valueOf(),
  nombrecompleto: data?.cliente?.nombrecompleto || null,
  tipodocumento: data?.cliente?.tipodocumento || null,
  nrodocumento: data?.cliente?.nrodocumento || null,
  vendedor: data?.vendedor || null,
  fechaemision: dayjs(data?.fechaemision) || dayjs(),
  fechaentrega: dayjs(data?.fechaentrega) || dayjs(),
  fechavalidez: dayjs(data?.fechavalidez) || dayjs(),
  moneda: data?.moneda || null,
  monedaprefijo: data?.monedaprefijo || null,
  contacto: data?.contacto || null,
  telefonocontacto: data?.telefonocontacto || null,
  inforeference: data?.inforeference || null,
  observacion: data?.observacion || null,
  montosubtotal: parseFloat(data?.montosubtotal) || 0,
  montoigvtotal: parseFloat(data?.montoigvtotal) || 0,
  montototalgravadas: parseFloat(data?.montototalgravadas) || 0,
  montototalexoneradas: parseFloat(data?.montototalexoneradas) || 0,
  montototalinafectas: parseFloat(data?.montototalinafectas) || 0,
  montototal: parseFloat(data?.montototal) || 0,
  detallecotizacion: data?.detallecotizacion || [],
  cliente:
    (data?.cliente && {
      ...data?.cliente,
      data: JSON.stringify(data?.cliente),
    }) ||
    null,
});

export const CotizacionScreen = ({ handleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const { activeCotizacion } = useSelector((state) => state.cotizacion);
  const handleSubmit = (values) => {
    let valuesData = {
      ...values,
      fechaemision: parseDateFormatBackEnd(values?.fechaemision),
      fechaentrega: parseDateFormatBackEnd(values?.fechaentrega),
      fechavalidez: parseDateFormatBackEnd(values?.fechavalidez),
      empresa: activeEmpleado?.empresa?.id,
      cliente: {
        ...JSON.parse(values?.cliente?.data),
        tipodocumento: values?.cliente?.tipodocumento,
      },
    };
    valuesData = cleanEmptyChildren(valuesData);
    if (activeCotizacion) dispatch(cotizacionStartUpdate(valuesData));
    else dispatch(cotizacionStartAdd(valuesData));
    handleCloseForm();
  };
  return (
    <Form.Provider
      onFormFinish={(name, { values, forms }) => {
        const { FormCotizacion } = forms;
        if (name === "ItemDetalleForm") {
          let detallecotizacion =
            FormCotizacion.getFieldValue("detallecotizacion") || [];
          const _existe =
            detallecotizacion?.filter((x) => x.id === values?.id)?.length > 0
              ? true
              : false;
          values = {
            ...values,
            valorigv: parseFloat(
              parseFloat(values?.cantidad * values?.valorigvunitario).toFixed(
                4,
              ),
            ),
            valorventabruto: parseFloat(
              parseFloat(values?.cantidad * values?.valorunitario).toFixed(4),
            ),
            valorventa: parseFloat(
              parseFloat(values?.cantidad * values?.preciounitario).toFixed(4),
            ),
          };
          if (!_existe) detallecotizacion = [...detallecotizacion, values];
          else
            detallecotizacion = detallecotizacion.map((e) =>
              e.id === values.id ? values : e,
            );
          FormCotizacion.setFieldValue("detallecotizacion", detallecotizacion);
        }
      }}
    >
      <FormUi
        name="FormCotizacion"
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(
          activeCotizacion || {
            moneda: activeEmpleado?.empresa?.moneda,
            monedaprefijo: activeEmpleado?.empresa?.moneda_prefijo,
            vendedor: activeEmpleado?.id,
          },
        )}
        handleSubmit={handleSubmit}
        form={form}
      >
        <CotizacionForm handleCloseForm={handleCloseForm} />
      </FormUi>
    </Form.Provider>
  );
};
